import { PaletteMode } from '@mui/material';
import { ChronosphereColorPalette, orange } from '../colors';

export const warningColor = (mode: PaletteMode): ChronosphereColorPalette => {
  return mode === 'light'
    ? {
        main: orange[400],
        highContrast: orange[700],
        lowContrast: orange[100],
      }
    : {
        main: orange[400],
        highContrast: orange[100],
        lowContrast: orange[800],
      };
};
